interface PageHeroProps {
  eyebrow?: string
  title: string
  subtitle?: string
  children?: React.ReactNode
}

const PageHero = ({ eyebrow, title, subtitle, children }: PageHeroProps) => (
  <section className="relative overflow-hidden bg-[#1a1612] text-white">
    <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top_right,_rgba(212,166,87,0.18),transparent_55%)]" />
    <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_bottom_left,_rgba(255,255,255,0.04),transparent_50%)]" />
    <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14 sm:py-16 lg:py-20">
      {eyebrow && (
        <p className="text-[11px] sm:text-xs uppercase tracking-[0.28em] text-primary-400 font-semibold mb-3">
          {eyebrow}
        </p>
      )}
      <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight max-w-3xl leading-tight">
        {title}
      </h1>
      {subtitle && (
        <p className="mt-4 text-base sm:text-lg text-white/70 max-w-2xl leading-relaxed">{subtitle}</p>
      )}
      {children && <div className="mt-8">{children}</div>}
    </div>
  </section>
)

export default PageHero
